<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 13.75H11.5M4.75 13.75H15.25C16.0784 13.75 16.75 13.0784 16.75 12.25V5.5C16.75 4.67157 16.0784 4 15.25 4H4.75C3.92157 4 3.25 4.67157 3.25 5.5V12.25C3.25 13.0784 3.92157 13.75 4.75 13.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
    <path d="M11.5 13.75H8.5V16.75H11.5V13.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'LandingPagesIcon'
}
</script>

